module.exports = __webpack_public_path__ + "img/qrc.c3cb0092.svg";